var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 205,
    viewBox: "0 0 217 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.462 70.4199V197.01C201.462 198.841 199.893 200.5 197.934 200.5H18.8145C16.9235 200.5 15.2874 198.908 15.2871 197.01V70.4199H201.462ZM75.7617 87.3877C69.1237 87.3877 63.2346 92.788 63.2344 99.8779V116.108C63.2344 122.767 68.6898 128.599 75.7617 128.599H140.987C147.625 128.599 153.515 123.198 153.515 116.108V99.8779C153.514 93.2197 148.059 87.3878 140.987 87.3877H75.7617Z",
    stroke: "#49712B",
    strokeWidth: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 4.5H208.722C210.535 4.50016 212.326 6.03913 212.5 8.40234V50.6826H4.5V7.99023C4.5 6.15918 6.06826 4.50023 8.02734 4.5Z",
    stroke: "#49712B",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageEmpty);
export default __webpack_public_path__ + "static/media/storage-empty.7ddf02b1b62bd58e6e6415d89a11e5cd.svg";
export { ForwardRef as ReactComponent };